export enum AcceptanceType {
  DISAGREE = 0,
  AGREE = 1,
}
